import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { authSlice, currentOrgStorageKey } from './auth.slice';
import type { RootState } from 'src/app/store/types';
import { setStorageValue } from 'src/common/util/useLocalStorage/setStorageValue';

// Owns mirroring the selected organization to localStorage: writes
// currentOrganizationId whenever it changes (clearing it when undefined), so
// the auth reducers stay pure. Restoring on load lives in auth.slice's
// initialState; signOut also clears the key defensively.
export const organizationPersistenceListener =
  createListenerMiddleware<RootState>();

organizationPersistenceListener.startListening({
  matcher: isAnyOf(
    authSlice.actions.signIn,
    authSlice.actions.changeOrganization
  ),
  effect: (_action, listenerApi) => {
    const { currentOrganizationId } = listenerApi.getState().auth;
    try {
      setStorageValue(currentOrgStorageKey, currentOrganizationId ?? '');
    } catch {
      // Best-effort: persistence runs inside dispatch, so a blocked/quota'd
      // storage write must not break the auth flow.
    }
  },
});
